import { Button, Col, Divider, Modal, Row, Space, Upload } from "antd";
import cx from "classnames";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import uploadStyles from "components/elements/upload/Upload.module.css";
import { Select } from "components/form";

import {
  beforeUpload,
  getBase64,
  uploadButton,
} from "components/elements/upload/Upload.utils";
import { CompanySignatureSchema } from "../../../features/company/schemas/companyDocumentSchema";
import styles from "./Modal.module.css";

function ModalSignature({
  width = 510,
  className = "",
  initialValues = {},
  isModalOpen = false,
  employeeOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    if (initialValues.signature) {
      setLoading(true);
      getBase64(initialValues.signature, (url) => {
        setImageUrl(url);
      });
    }
  }, [initialValues.signature]);

  return (
    <Modal
      title={
        <b className={styles.infoTopic}>
          {initialValues.documentTypeName || "-"}
        </b>
      }
      open={isModalOpen}
      onCancel={onCancel}
      className={cx(styles.customStyle, className)}
      width={width}
      footer={null}
      maskClosable={false}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={CompanySignatureSchema}
        onSubmit={onSubmit}
      >
        {({ setFieldValue = () => { } }) => {
          const onCoverUpload = (info) => {
            setFieldValue("signature", info.file);
            getBase64(info.file, (url) => {
              setLoading(false);
              setImageUrl(url);
            });
          };

          return (
            <Form>
              <Space
                className={styles.container}
                size={12}
                direction="vertical"
              >
                <Row gutter={[0, 10]}>
                  <Col span={24}>
                    <Select
                      name="authorized"
                      label={t("document.label.authorized_modal")}
                      placeholder="Authorized"
                      size="large"
                      options={employeeOptions}
                      disabled
                      required
                    />
                  </Col>
                  <Col span={24} style={{ marginBottom: "12px" }}>
                    <div style={{ paddingBottom: "10px" }}>{t("document.label.signature_modal")}<span style={{ color: "red" }}>*</span></div>
                    {imageUrl ? (
                      <div className={styles.sealContainer}>
                        <img
                          src={imageUrl}
                          alt=""
                          style={{ width: "100%", borderRadius: "10px" }}
                        />
                      </div>
                    ) : (
                      <Upload
                        name="signature"
                        className={uploadStyles.containerSecond}
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onChange={onCoverUpload}
                        action={null}
                      >
                        {uploadButton(loading)}
                      </Upload>
                    )}
                  </Col>
                </Row>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default ModalSignature;
